<template>
  <div id="hres7de-detail-tab2" class="panel box-collapse border-color-skin">
    <div class="box-header with-border box-header-collapse collapsed  tab-header" data-toggle="collapse" data-parent="#accordion" href="#tab2">
      <h3 class="box-title">
        <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRES7DEP2']['20'] }}
      </h3>
    </div>
    <div id="tab2" class="panel-collapse collapse tab-detail">
      <div class="panel-body">
        <div class="col-md-5">
          <form class="form-horizontal">
            <div class="form-group margin-b-5">
              <label class="col-md-5 control-label">{{ labels['HRES7DEP2']['20'] }}</label>
              <div class="col-md-7">
                <div class="form-control readonly-field-color">{{ detailTab2.detail.codform }} - {{ detailTab2.detail.desc_codform }}</div>
              </div>
            </div>
          </form>

          <form class="form-horizontal">
            <div class="form-group margin-b-5">
              <label class="col-md-5 control-label">{{ labels['HRES7DEP2']['80'] }}</label>
              <div class="col-md-7">
                <textarea class="form-control textarea-text" 
                          v-model="detailTab2.detail.destrevl"
                          maxlength="100" 
                          v-validate="'max:100'"
                          data-vv-name="destrevl"
                          :has-error="errors.has('destrevl')"></textarea> 
                <div class="text-error" v-show="errors.has('destrevl')">{{errors.first('destrevl')}}</div>
                <div class="remark-limit-character">{{ dispLimitLabel(100) }}</div> 
              </div>
            </div>
          </form>
          <div class="box-footer">
            <button type="button" class="btn bg-color-skin" @click="save()"><i class="fa fa-check-circle"></i>{{ labelsButton['save'] }}</button>  
          </div>
        </div>

        <div class="col-md-7" v-if="detailTab2.table1.rows.length > 0">
          <div class="col-md-12 clear-padding">
            <div class="evaluation-wrapper">
              <template v-for="dataGroup in detailTab2.table1.rows">
                <group  :labels="labels"
                        :dataGroup="dataGroup"
                        :choices="detailTab2.table2.rows"
                        name="tab2"/>
              </template>
            </div>
          </div>
          <div class="col-md-12 clear-padding">
            <div class="evaluation-sum">
              {{ labels['HRES7DEP2']['70'] }} {{ calResultScore(detailTab2.table1.rows) }}/{{ calTotalScore(detailTab2.table1.rows) }}
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import group from 'components/hres7de/group'
import { constLabels } from 'assets/js/constLabels.js'
import { numberFormat } from 'assets/js/numberFormat.js'

export default {
  name: 'hres7de-detail-tab2',
  props: [ 'labels', 'detailTab2', 'labelsButton', 'detail', 'postHres7deTab2Save', 'searchIndex', 'codeval', 'indexSelected', 'searchDetail' ],
  watch: {
    'detailTab2.detail.destrevl' () {
      this.$validator.validate('destrevl', this.detailTab2.detail.destrevl).catch(e => {})
    },
    detailTab2 () {
      this.$nextTick(() => {
        this.errors.clear()
      })
    }
  },
  methods: {
    dispLimitLabel (limit) {
      return constLabels('limitTo') + ' ' + limit + ' ' + constLabels('characters')
    },
    saveParams () {
      return {
        codempid: this.codeval,
        searchIndex: this.searchIndex,
        searchDetail: this.searchDetail,
        detailTab2: this.detailTab2,
        indexSelected: this.indexSelected
      }
    },
    calResultScore (dataGroups) {
      return dataGroups.map((dataGroup) => {
        return numberFormat(parseFloat(dataGroup.qtyscore))
      }).reduce((a, b) => {
        return numberFormat(parseFloat(a) + parseFloat(b))
      })
    },
    calTotalScore (dataGroups) {
      return dataGroups.map((dataGroup) => {
        return numberFormat(parseFloat(dataGroup.qtyfscor))
      }).reduce((a, b) => {
        return numberFormat(parseFloat(a) + parseFloat(b))
      })
    },
    save () {
      let _this = this
      this.$validator.validateAll().then(result => {
        if (result) {
          _this.postHres7deTab2Save(_this.saveParams())
        }
      })
    }
  },
  components: {
    group
  }

}
</script>



// WEBPACK FOOTER //
// detailTab2.vue?4264ee48